import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from 'formik-material-ui';
import { FormControlLabel, makeStyles, FormHelperText, Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const useInputStyles = makeStyles((theme) => ({
  wrapper: {
    width: '100%',
    position: 'relative',
  },
  formControlLabel: {
    width: '100%',
    maxWidth: theme.custom.inputs.maxWidth,
    justifyContent: 'space-between',
    marginBottom: theme.spacing(3),
  },
  helperText: {
    position: 'absolute',
    bottom: 10,
    left: 0,
  },
}));

const InputSwitch = ({ hint, label, ...props }) => {
  const classes = useInputStyles();

  const { t } = useTranslation();

  const {
    field: { value },
  } = props;

  return (
    <Box className={classes.wrapper}>
      <FormControlLabel
        className={classes.formControlLabel}
        label={t(label)}
        labelPlacement="start"
        control={<Switch type="checkbox" {...props} checked={value} color="primary" />}
      />
      <FormHelperText className={classes.helperText} variant="filled" required margin="dense">
        {hint}
      </FormHelperText>
    </Box>
  );
};

InputSwitch.propTypes = {
  label: PropTypes.string.isRequired,
  hint: PropTypes.string,
};

InputSwitch.defaultProps = {
  hint: null,
};

export default InputSwitch;
